<template>
  <article id="settings.products" class="products">
    <AdminMatrixDataTable
      v-if="userStore.isCustomerProductManager"
      :content="{
        name: 'customer_product_matrix',
        category: 'matrix_admin',
        type: 'sphere_admin',
        class_name: 'CustomerProductMatrix',
        url: '',
        kwargs: {
          fields: [],
          url: 'customers/products/matrix/',
          page_title: 'The products this customer has',
          page_description: '',
        },
      }"
      class="border"
    />
    <DataTable
      v-else
      :loading="loading"
      :rows="products"
      :cols-map="{Name: 'name'}"
      sortable
      searchable
      :error-message="errorMessage"
      class="flex-grow-1 w-100 overflow-hidden border"
      @read="readProducts"
    />
  </article>
</template>
<script setup lang="ts">
import {apiGetActiveProducts} from '@/api/apolloPlatform/customers';
const userStore = useUserStore();
const customersStore = useCustomersStore();
const products = ref<{name: string; sku: string}[]>([]);
const loading = ref(true);
const errorMessage = ref('');

const readProducts = async () => {
  loading.value = true;
  try {
    const {data} = await apiGetActiveProducts(customersStore.selectedCustomer!.customer.id);
    products.value = data;
  } catch (error) {
    errorMessage.value = String(error);
  } finally {
    loading.value = false;
  }
};

onMounted(readProducts);
</script>
